const axios = require('axios');

export default () => {
    const promise = new Promise((resolve) => {
        axios.get('orders-api/get-cart').then((response) => {
            resolve(response.data);
        });
    });
    return promise;
}
